<p-dialog
  #dialogEditContato
  [modal]="true"
  [visible]="true"
  [position]="'top'"
  (visibleChange)="dialog.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex aling-items-center">
      <span class="font-light fs-normal">
        {{ data.contato.contato ? 'Editar contato' : 'Adicionar contato' }}
      </span>
      <i class="pi pi-fw pi-phone ml-2 text-primary"></i>
    </div>
  </ng-template>
  <div class="row">
    <div class="col-md-12 mt-2 flex-column">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>
          Contato
        </mat-label>
        <input matInput type="text" [formControl]="form.get('contato')" />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('contato').touched &&
          form.get('contato').hasError('required')
        "
      >
        O contato é requerido.
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('contato').touched &&
          form.get('contato').hasError('isEmptyValue')
        "
      >
        Valor inválido: remova os espaços em branco!
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('contato').touched &&
          form.get('contato').hasError('maxlength')
        "
      >
        Contato aceita no máximo 100 caracteres
      </small>
    </div>
    <chip-input
      class="col-md-12 mt-2"
      style="width: 100% !important;"
      id="tag-catalogo"
      placeholder="Tags do contato"
      [tagContato]="true"
      [newContato]="!data.contato.id"
      [initialValue]="data.contato.tag"
      (onChange)="onChangeTag($event)"
    ></chip-input>
  </div>
  <ng-template pTemplate="footer">
    <div class="width-100 mb-3 flex align-items-center justify-content-between">
      <button
        pButton
        pRipple
        severity="danger"
        text
        rounded
        (click)="cancelar()"
        label="Cancelar"
        icon="pi pi-fw pi-times-circle"
        iconPos="right"
      ></button>
      <button
        pButton
        pRipple
        severity="success"
        outlined
        rounded
        label="Salvar"
        icon="pi pi-fw pi-save"
        iconPos="right"
        (click)="salvar()"
        [disabled]="!form.valid"
      ></button>
    </div>
  </ng-template>
</p-dialog>
